import * as React from "react";

const CloseSVG = ({ width = 20, height, fill = "currentColor", ...rest }) => (
  <svg
    width={width}
    height={height || width}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path d="M6.95625 5.36625L10.4062 1.91625C10.8412 1.48125 10.8412 0.76125 10.4062 0.32625C9.97125 -0.10875 9.25125 -0.10875 8.81625 0.32625L5.36625 3.77625L1.91625 0.32625C1.48125 -0.10875 0.76125 -0.10875 0.32625 0.32625C-0.10875 0.76125 -0.10875 1.48125 0.32625 1.91625L3.77625 5.36625L0.32625 8.81625C-0.10875 9.25125 -0.10875 9.97125 0.32625 10.4062C0.55125 10.6312 0.83625 10.7362 1.12125 10.7362C1.40625 10.7362 1.69125 10.6312 1.91625 10.4062L5.36625 6.95625L8.81625 10.4062C9.04125 10.6312 9.32625 10.7362 9.61125 10.7362C9.89625 10.7362 10.1812 10.6312 10.4062 10.4062C10.8412 9.97125 10.8412 9.25125 10.4062 8.81625L6.95625 5.36625Z" fill={fill} />
  </svg>
);

export default CloseSVG;
